import { render } from "./CoprarConvert.vue?vue&type=template&id=4dc2bf4d&scoped=true"
import script from "./CoprarConvert.vue?vue&type=script&lang=js"
export * from "./CoprarConvert.vue?vue&type=script&lang=js"

import "./CoprarConvert.vue?vue&type=style&index=0&id=4dc2bf4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc2bf4d"]])

export default __exports__